module.exports = __webpack_public_path__ + "img/water-tank.4450761.jpg";